import { FlexLayout, H2, Icon } from '@deity/falcon-ui';
import type { FC } from 'react';
import { Link } from 'react-router-dom';

type PackageNameLineProps = {
  packageName: string;
  baseUrl: string;
};
const PackageNameLine: FC<PackageNameLineProps> = ({ baseUrl, packageName }) => (
  <FlexLayout alignItems="center">
    <Icon mr="xs" src="dashboard" color="primary" style={{ width: '28px', height: '28px' }} />
    <Link to={`${baseUrl}/package`} style={{ textDecoration: 'none' }}>
      <H2 color="black">{packageName}</H2>
    </Link>
  </FlexLayout>
);

export default PackageNameLine;
